import { jsx as _jsx } from "react/jsx-runtime";
import { ITEMS_PER_PAGE } from "../../constants";
import { AccordionProductList } from "./AccordionProductList";
import { ProductList } from "./ProductList";
export const EditionProductSection = (param)=>{
    let { isLastDepthByTree , productsQuery , selectedSort , onSortChange , currentPage , onPageChange , purchaseUrl , isCategoryLoading  } = param;
    const { products , totalCount , sortOptions , isLoading , productGroups , groupedTotalCount  } = productsQuery;
    // 카테고리 데이터 로딩 중이면 아코디언 스켈레톤 표시 (isLastDepthByTree가 아직 정확하지 않을 수 있음)
    if (isCategoryLoading) {
        return /*#__PURE__*/ _jsx(AccordionProductList, {
            groups: [],
            totalCount: 0,
            isLoading: true,
            purchaseUrl: purchaseUrl
        });
    }
    // 마지막 depth: 아코디언 (정렬은 단원순 고정)
    if (isLastDepthByTree) {
        var _productGroups_;
        return /*#__PURE__*/ _jsx(AccordionProductList, {
            groups: productGroups,
            totalCount: groupedTotalCount,
            isLoading: isLoading,
            defaultExpandedIds: ((_productGroups_ = productGroups[0]) === null || _productGroups_ === void 0 ? void 0 : _productGroups_.id) ? [
                productGroups[0].id
            ] : [],
            purchaseUrl: purchaseUrl
        });
    }
    // 일반: 리스트
    return /*#__PURE__*/ _jsx(ProductList, {
        items: products,
        totalCount: totalCount,
        sortOptions: sortOptions,
        selectedSort: selectedSort,
        onSortChange: onSortChange,
        isLoading: isLoading,
        pagination: {
            currentPage,
            totalPages: Math.ceil(totalCount / ITEMS_PER_PAGE),
            onPageChange
        },
        purchaseUrl: purchaseUrl
    });
};
